export default __webpack_public_path__ + "static/1_16-b6177b60531a9e5b5fd83948620d289e.png";